import {Controller} from "@hotwired/stimulus"

class ToggleVisibilityController extends Controller {
  toggle() {
    if (this.element.classList.contains("open")) {
      this.element.classList.remove("open")
    } else {
      this.element.classList.add("open")
    }
  }

  expand(event) {
    this.element.classList.add("open")
    event.currentTarget.setAttribute("aria-expanded", "true")
  }
}

export default ToggleVisibilityController
